import { gql } from '@apollo/client';
import { BASE_COMPANY_FRAGMENT } from './company.fragments';
import { BASE_SITE_FRAGMENT } from './site.fragments';

export const DOCUMENT_FRAGMENT = gql`
  fragment documentValues on Document {
    id
    path
    url
    title
    createdTimestamp
    visibility
    expiryDate
    issuedDate
    category
    usageCount @client
    status @client
    impactClaimCount
    createdBy {
      id
      name
      logo {
        url
        imageId
      }
    }
    certificateCatalogItem {
      id
      title
      description
      imageUrl
      status
      requestedByUserEmail
      requestedTimestamp
    }
    linkedSites {
      edges {
        node {
          ...baseSiteValues
        }
      }
    }
    ownedBy {
      ...companyBaseValues
    }
    comment
  }
  ${BASE_COMPANY_FRAGMENT}
  ${BASE_SITE_FRAGMENT}
`;
